import { isIOS } from "../utils/platform"

const space = 15
const generalSpace = `${space}px`

const colors = {
  text: '14px',
  textInactive: "rgb(77,77,77)",
  radioInactive: "rgb(155,155,155)",
  planetBase: "#E8F1FE",
  orange: '#ff5722',
  darkOrange: '#e64511',
  lightOrange: '#fb6e41',
  white: '#fff',
  gray: ['#4d4d4d', '#999', '#ccc', '#ececec', '#e9e9e9', '#f0f0f0'],
  red: '#d32f2f',
  green: '#47bb82',
  darkGreen: '#40a373',
  border: '1px solid #ff5722',
  gradient:
    'linear-gradient(112deg, rgba(113,89,193,1) 0%, rgba(155,73,193,1) 100%);',
}
export default Object.freeze({
  colors,
  fontSize: {
    topHeader: '1.1rem',
    header: '1rem',
    text: '0.875rem',
    small: '.75rem',
  },
  viewports: {
    iphone5s: '320px',
    smartphone: '360px',
    tablet: '720px',
    desktop: '1280px',
  },
  header: {
    height: '60px',
  },
  button: {
    default: {
      backgroundColor: colors.orange,
      color: colors.white,
      active: colors.darkOrange,
      border: `1px solid ${colors.orange}`,
      cursor: 'pointer',
    },
    invert: {
      backgroundColor: colors.white,
      color: colors.orange,
      active: colors.gray[2],
      border: `1px solid ${colors.gray[2]}`,
      cursor: 'pointer',
    },
    inactive: {
      backgroundColor: colors.gray[3],
      color: colors.gray[2],
      active: colors.gray[3],
      border: 'none',
      cursor: 'default',
    },
    pay: {
      backgroundColor: colors.green,
      color: colors.white,
      active: colors.darkGreen,
      border: 'none',
      cursor: 'pointer',
    },
  },
  padding: generalSpace,
  margin: generalSpace,

  top: generalSpace,
  right: generalSpace,
  left: generalSpace,
  bottom: generalSpace,

  halfSpace: `${space / 2}px`,
  lineHeight: '25px',
  maxWidth: '420px',
  borderRadius: isIOS ? '10px' : '5px',
})
